import React from "react";

import { Badge } from "react-bootstrap";
import Select from "react-select";

import { Button } from "aible";

import { getIsRecipesEnabled } from "containers/Recipe/reducer";

import DatasetTile from "components/Tiles/DatasetTile";

import AibleStep from "containers/CreateWizard/AibleStep";
import { DATA_CHECKS } from "containers/Home/reducer";

import RecipeItem from "containers/View/Item/RecipeItem";

import styles from "./style.module.css";

import TableLoader, { TableColumn, TableRow } from "components/Table/Table.js";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

export default class ChooseDataset extends React.PureComponent {
  state = {
    nextStep: false
  };

  countDuplicates(a, b) {
    let count = -1;

    for (const aKey of Object.keys(a)) {
      if (b[aKey] !== undefined) {
        count++;
      }
    }

    for (const k of Object.keys(this.state)) {
      count++;
    }

    return count;
  }

  renderOriginalDataset(dataset, selectedDataset) {
    const {
      id,
      columnDescription,
      updateColumnDescription,
      selectedFields,
      updateSelection,
      options,
      isForecast,
      blueprintId,
      isEditBlueprint
    } = this.props;

    const isBlueprint = true;

    const headers = ["Field", "Column", "Description"];

    const rows =
      dataset === undefined
        ? []
        : Object.keys(dataset.fields).map((fKey, index) => {
            const field = dataset.fields[fKey];
            const isOutcome = dataset.outcome === field.label;

            const data = [
              "",
              field.label,
              field.type,
              field.warnings ? (field.warnings.length === 0 ? "" : field.warnings.length) : ""
            ];

            let isMatch =
              (selectedDataset && selectedDataset.fields && selectedDataset.fields[fKey] !== undefined) ||
              selectedFields[fKey];

            let match =
              selectedDataset && selectedDataset.fields[fKey] !== undefined
                ? fKey
                : selectedFields[fKey]
                  ? selectedFields[fKey].value
                  : undefined;

            Object.keys(selectedFields).forEach((k) => {
              if (selectedFields[k] && selectedFields[k].value && selectedFields[k].value.label) {
                if (selectedFields[k].found === fKey) {
                  isMatch = true;
                }
                if (selectedFields[k].found === fKey) {
                  match = selectedFields[k].value.value;
                }
              }
            });

            const sOptions =
              selectedDataset && selectedDataset.fields
                ? Object.keys(selectedDataset.fields).map((f) => ({
                    label: f,
                    value: f
                  }))
                : [];

            return {
              row: (
                <TableRow className={styles.fieldRow + " " + (isMatch ? styles.matchRow : " ")} height={30} key={index}>
                  <TableColumn>
                    <span>{data[1]}</span>
                    {isOutcome && <Badge className={styles.outcomeBadge}>{"Outcome"}</Badge>}
                    {isMatch && <Badge className={styles.aibleBadge}>{"Match"}</Badge>}
                  </TableColumn>
                  <TableColumn>
                    <div className={styles.capitalize}>{data[2]}</div>
                  </TableColumn>
                  <TableColumn style={{ width: "66%" }}>
                    <div>
                      {blueprintId === "new" || isEditBlueprint ? (
                        <LineInput
                          isBox
                          style={{
                            height: "50px",
                            justifyContent: "flex-start"
                          }}
                          placeholder="Add Description"
                          value={columnDescription ? columnDescription[fKey] : undefined}
                          onChange={(value) => updateColumnDescription(blueprintId, fKey, value)}
                        />
                      ) : columnDescription ? (
                        <div>
                          {this.state && this.state[index] !== true && (
                            <div>{columnDescription[fKey] ? columnDescription[fKey] : ""}</div>
                          )}
                          {this.state && this.state[index] === true && (
                            <LineInput
                              isBox
                              style={{
                                height: "50px",
                                justifyContent: "flex-start"
                              }}
                              placeholder="Add Description"
                              defaultValue={columnDescription ? columnDescription[fKey] : undefined}
                              onChange={(value) => {
                                updateColumnDescription(blueprintId, fKey, value);
                                return this.setState({ [index]: false });
                              }}
                            />
                          )}
                        </div>
                      ) : undefined}
                    </div>
                  </TableColumn>
                </TableRow>
              ),
              data: data
            };
          });

    return (
      <div className={styles.original}>
        {dataset && dataset.id && (
          <div className={styles.oHolder}>
            <div className={styles.table + " " + styles.oTable}>
              <TableLoader minHeight={"240px"} height={300} headers={headers} rows={rows} hideSearch />
            </div>
          </div>
        )}
      </div>
    );
  }
  renderDataset(originalDataset, selectedDataset, hideButton, isBlueprint) {
    const {
      id,
      columnDescription,
      updateColumnDescription,
      selectedFields,
      updateSelection,
      options,
      isForecast,
      blueprintId,
      splitOptions,
      updateSplitColumn,
      splitColumn,
      ignored,
      transformed
    } = this.props;

    const updatedColumns = (selectedDataset && selectedDataset.warnings) || [];
    const ignoredFields = (Object.keys(ignored) || []).filter((key) => ignored[key]);
    const ignoredCols = ignoredFields.concat(
      updatedColumns.filter((w) => w.message.includes("ignored")).map((w) => w.message)
    );

    let fakeDataChecks = DATA_CHECKS;

    return (
      <div className={styles.dHolder}>
        {selectedDataset && (
          <AibleStep
            id={id}
            bId={"chooseDataset_after"}
            message={"Dataset selected: " + selectedDataset.label}
            secondaryMessage={
              selectedDataset && originalDataset && originalDataset.id
                ? this.countDuplicates(selectedDataset.fields, originalDataset.fields) + " columns match"
                : ""
            }
          />
        )}
        <div className={styles.iHolder}>
          <div className={styles.dButtons}>
            <DatasetTile dataset={selectedDataset} />
            {selectedDataset === undefined || (options && options["lock"] === true) ? (
              <div />
            ) : (
              <div onClick={() => updateSelection({ value: undefined })}>
                <Button>{"Change"}</Button>
              </div>
            )}
          </div>
          <div className={styles.iCol}>
            <div className={styles.iHeader}>
              <span className={styles.iBold}>{fakeDataChecks.length}</span>
              {"Data Validation Checks Completed"}
            </div>
            <div className={styles.iHeader}>
              <span className={styles.iBold}>{selectedDataset.warnings && selectedDataset.warnings.length}</span>
              {"Updates Applied"}
            </div>
            <div className={styles.iContent}>
              {selectedDataset.warnings &&
                selectedDataset.warnings.map((w, i) => (
                  <div className={styles.iRow} key={i}>
                    {w.message}
                  </div>
                ))}
            </div>
          </div>
          {/* <div className={styles.iCol}>
            <div className={styles.iHeader}>
              <span className={styles.iBold}>
                {selectedDataset.warnings && selectedDataset.warnings.length}
              </span>
              {"Updates Applied"}
            </div>
            <div className={styles.iContent}>
              {selectedDataset.warnings.map((w, i) => (
                <div className={styles.iRow} key={i}>
                  {w.message}
                </div>
              ))}
            </div>
          </div> */}
          <div className={styles.iCol}>
            <div className={styles.iHeader}>
              <span className={styles.iBold}>{ignoredCols && ignoredCols.length}</span>
              {" Columns Ignored"}
            </div>
            <div className={styles.iContent}>
              {ignoredCols.map((w, i) => (
                <div className={styles.iRow} key={i}>
                  {w}
                </div>
              ))}
            </div>
          </div>
          <div className={styles.iCol}>
            <div className={styles.iHeader}>
              <span className={styles.iBold}>{transformed && transformed.length}</span>
              {" Columns Added"}
            </div>
            <div className={styles.iContent}>
              {transformed.map((w, i) => (
                <div className={styles.iRow} key={i}>
                  {(w.fieldOne && w.fieldOne.label ? w.fieldOne.label : "") +
                    " " +
                    (w.operation && w.operation.label
                      ? w.operation.label == "Interaction"
                        ? "and"
                        : w.operation.label
                      : "") +
                    " " +
                    (w.fieldTwo && w.fieldTwo.label ? w.fieldTwo.label : "")}
                </div>
              ))}
            </div>
          </div>
        </div>
        <AibleStep
          id={id}
          bId="chooseSplit"
          message={
            "Would you like to split on a column? (This step is optional and can be completed later after frontier is trained)"
          }
          secondaryMessage={""}
          isBreak
        >
          <div className={styles.splitField}>
            <Select
              menuPlacement="top"
              isClearable
              options={splitOptions}
              onChange={(val) => updateSplitColumn(val ? val.value : val)}
              value={splitColumn ? { label: splitColumn, value: splitColumn } : undefined}
            />
          </div>
        </AibleStep>
      </div>
    );
  }

  render() {
    const {
      selection,
      selectedDataset,
      datasetOptions,
      datasets,
      updateSelection,
      id,
      isEditBlueprint,
      blueprintId,
      originalDataset,
      importRecipeView,
      deployRecipeView,
      updateImportRecipeId,
      updateDeployRecipeId,
      datasetView,
      isShow,
      options,
      importRecipeId,
      deployRecipeId
    } = this.props;

    const { nextStep, buildRecipe } = this.state;

    if (id !== "new" && (datasets === undefined || datasets.length === 0)) {
      return <LoadingIndicator />;
    }

    return (
      <div className={styles.body}>
        {blueprintId ? (
          <div className={styles.createBlueprint}>
            {originalDataset && originalDataset.id && (
              <AibleStep
                id={id}
                bId={"displayContent"}
                message={
                  "This Blueprint contains " +
                  (originalDataset && originalDataset.fields ? Object.keys(originalDataset.fields).length : " ...") +
                  " columns. It was based off the " +
                  originalDataset.label +
                  " Dataset. " +
                  "The original outcome was " +
                  originalDataset.outcome +
                  "."
                }
                secondaryMessage={
                  (importRecipeId === undefined ? "" : "This Blueprint includes a recipe to import data. ") +
                  (selectedDataset === undefined ? "Select a Dataset to see how your data compares." : "")
                }
                style={{ marginBottom: "10px" }}
              />
            )}
            {originalDataset && this.renderOriginalDataset(originalDataset, selectedDataset)}
          </div>
        ) : (
          <div>
            <AibleStep message={"Welcome to Aible. Let me help you build your Real-World AI!"} />
          </div>
        )}
        <div className={styles.dataHolder}>
          {getIsRecipesEnabled() && isEditBlueprint && (
            <div>
              {buildRecipe !== true && importRecipeId === undefined ? (
                <div>
                  <AibleStep
                    bId={"displayContent"}
                    message={"Would you like to add a recipe to import data?"}
                    secondaryMessage={
                      "This is an optional feature. You can also use an existing dataset or upload a new one."
                    }
                    style={{ marginBottom: "10px" }}
                  />
                  <div className={styles.bCenter}>
                    <Button onClick={() => this.setState({ buildRecipe: true })}>{"Use Recipe"}</Button>
                  </div>
                </div>
              ) : (
                <div>
                  <div className={styles.datasetHolder}>
                    <AibleStep
                      bId={"displayContent"}
                      message={importRecipeId === undefined ? "Let's select a recipe to use" : "Using import recipe"}
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  <div className={styles.dataBody}>
                    <div
                      className={importRecipeId === undefined ? styles.datasetList : ""}
                      style={
                        importRecipeId === undefined || blueprintId !== undefined
                          ? {}
                          : {
                              background: "rgb(146, 207, 72, 0.15)",
                              alignItems: "center",
                              border: "1px solid rgb(146, 207, 72, 0.55)"
                            }
                      }
                    >
                      {importRecipeId === undefined ? (
                        importRecipeView
                      ) : (
                        <div className={styles.flexList}>
                          <RecipeItem id={importRecipeId} />
                          <div
                            onClick={() => {
                              updateImportRecipeId(undefined);
                              this.setState({ buildRecipe: true });
                            }}
                          >
                            <Button>{"Change"}</Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className={styles.datasetHolder}>
                    <AibleStep
                      bId={"displayContent"}
                      message={"Would you like to add a recipe to deploy models created by this blueprint?"}
                      secondaryMessage={
                        "This is an optional feature. You can still deploy models without selecting a recipe."
                      }
                      style={{ marginBottom: "10px" }}
                    />
                  </div>
                  <div className={styles.dataBody}>
                    <div
                      className={deployRecipeId === undefined ? styles.datasetList : ""}
                      style={
                        selectedDataset === undefined || blueprintId !== undefined
                          ? {}
                          : {
                              background: "rgb(146, 207, 72, 0.15)",
                              alignItems: "center",
                              border: "1px solid rgb(146, 207, 72, 0.55)"
                            }
                      }
                    >
                      {deployRecipeId === undefined ? (
                        deployRecipeView
                      ) : (
                        <div className={styles.flexList}>
                          <RecipeItem id={deployRecipeId} />
                          <div
                            onClick={() => {
                              updateDeployRecipeId(undefined);
                              this.setState({ buildRecipe: true });
                            }}
                          >
                            <Button>{"Change"}</Button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
          {selectedDataset === undefined && (
            <div className={styles.datasetHolder}>
              <AibleStep
                id={id}
                bId={"chooseDataset"}
                message={"OK, lets choose a dataset:"}
                style={{ marginBottom: "10px" }}
              />
            </div>
          )}
          {selectedDataset === undefined && (
            <div className={styles.dataBody}>
              <div
                className={styles.datasetList}
                style={
                  selectedDataset === undefined || blueprintId !== undefined
                    ? {}
                    : {
                        background: "rgb(146, 207, 72, 0.15)",
                        alignItems: "center",
                        border: "1px solid rgb(146, 207, 72, 0.55)"
                      }
                }
              >
                {datasetView}
              </div>
            </div>
          )}
          {selectedDataset !== undefined && this.renderDataset(originalDataset, selectedDataset)}
        </div>
      </div>
    );
  }
}
